import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class BaseService {
  constructor(private _http: HttpClient) { }

  public getFile(url = ''): Observable<Blob> {
    const fullUrl = `${environment.wildApiUrl}${url}`;
    return this._http.get(fullUrl, { responseType: 'blob' });
  }
  public get(url = '', params: HttpParams = new HttpParams()): Observable<any> {
  
    const fullUrl = `${environment.wildApiUrl}${url}`;
    let headers = new HttpHeaders();
    let s = localStorage.getItem('wt');
    let session;
    if (s != null) {
      session = JSON.parse(s);
    }
    let token = session.TokenId;
    if (token.length > 15) {
      headers = headers
        .append('Authorization', String(token))
        .append('U', String(session?.User_ID));
    }

    return this._http
      .get<any>(fullUrl, { params, headers })
      .pipe(map((result: any) => result));
  }

  public delete(
    url = '',
    params: HttpParams = new HttpParams()
  ): Observable<any> {
    const fullUrl = `${environment.wildApiUrl}${url}`;
    let headers = new HttpHeaders();
    let s = localStorage.getItem('wt');
    let session;
    if (s != null) {
      session = JSON.parse(s);
    }
    let token = session.TokenId;
    if (token.length > 15) {
      headers = headers
        .append('Authorization', String(token))
        .append('U', String(session?.User_ID));
    }

    return this._http
      .delete(fullUrl, { params, headers })
      .pipe(map((result: any) => result));
  }

  public postLogin(data: any, url = ''): Observable<any> {
    const fullUrl = `${environment.authApiUrl}${url}`;

    return this._http
      .post<any>(fullUrl, data)
      .pipe(map((result: any) => result));
  }

  private getBase(key: string) {
    switch (key) {
      case 'WILD':
        return environment.wildApiUrl;
      case 'S3':
        return environment.s3file;
    }
    return '';
  }
  public post(data: any, url = '', key = 'WILD', ctype = '0'): Observable<any> {
    const fullUrl = `${this.getBase(key)}${url}`;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');

    if (key != 'WILD') {
      headers = headers.append('AppId', environment.appId.toString());
      headers = headers.append('AppType', "1");
    }

    let s = localStorage.getItem('wt');
    let session;
    if (s != null) {
      session = JSON.parse(s);
    }
    if (!session) {
      let ss = localStorage.getItem('wtt');
      if (ss) {
        session = JSON.parse(ss);
      }

    }

    if (session) {
      let token = session.TokenId;
      headers = headers
        .append('Authorization', String(token))
        .append('U', String(session?.User_ID));
    }
    if (ctype === '1') {
      return this._http
        .post(fullUrl, data, { responseType: 'text', headers: headers });


    }
    else {
      return this._http
        .post<any>(fullUrl, data, { headers: headers })
        .pipe(map((result: any) => result));
    }
  }

  public postblob(data: any, url = '', key = 'WILD'): Observable<any> {
    const fullUrl = `${this.getBase(key)}${url}`;
    let headers = new HttpHeaders();
    if (key != 'WILD') {
      headers = headers.append('AppId', environment.appId.toString());
      headers = headers.append('AppType', "1");
    }
    let s = localStorage.getItem('wt');
    let session;
    if (s != null) {
      session = JSON.parse(s);
    }
    let token = session.TokenId;

    if (token.length > 15) {
     headers = headers
        .append('Authorization', String(token))
        .append('U', String(session?.User_ID));
    }
    headers = headers.append('Content-Type', 'application/json');




    return this._http
      .post(fullUrl, data, { headers });

  }
  public postblobdrager(data: any, url = '', key = 'WILD'): Observable<any> {
    const fullUrl = `${this.getBase(key)}${url}`;
    let headers = new HttpHeaders();
    if (key != 'WILD') {
      headers = headers.append('AppId', environment.appId.toString());
      headers = headers.append('AppType', "1");
    }
    let s = localStorage.getItem('wt');
    let session;
    if (s != null) {
      session = JSON.parse(s);
    }
    let token = session.TokenId;

    if (token.length > 15) {
      headers = headers
        .append('Authorization', String(token))
        .append('U', String(session?.User_ID));
    }
    headers = headers.append('Content-Type', 'application/json');




    return this._http
      .post(fullUrl, data, { responseType: 'text', headers: headers });

  }

  public put(data: any, url = ''): Observable<any> {
    const fullUrl = `${environment.wildApiUrl}${url}`;
    let headers = new HttpHeaders();
    let s = localStorage.getItem('wt');
    let session;
    if (s != null) {
      session = JSON.parse(s);
    }
    let token = session.TokenId;

    if (token.length > 15) {
     headers = headers
        .append('Authorization', String(token))
        .append('U', String(session?.User_ID));
    }


    return this._http
      .put(fullUrl, data, { headers })
      .pipe(map((result: any) => result));
  }

  public patch(data: any, url = ''): Observable<any> {
    const fullUrl = `${environment.wildApiUrl}${url}`;
    let headers = new HttpHeaders();
    let s = localStorage.getItem('wt');
    let session;
    if (s != null) {
      session = JSON.parse(s);
    }
    let token = session.TokenId;

    if (token.length > 15) {
       headers = headers
        .append('Authorization', String(token))
        .append('U', String(session?.User_ID));
    }
    return this._http
      .patch(fullUrl, data, { headers })
      .pipe(map((result: any) => result));
  }
}
